import { ClaimDetailsContainer } from './claim-details.container';

export { claimDetailsReducer } from './state/claim-details.reducer';
export { claimDetailsSaga } from './state/claim-details.saga';
export default ClaimDetailsContainer;
